$(document).ready(function() {
	$('body').addClass('vi-size-little');

	$(document).on('click', '.js-vi-size-little', function() {
		$('body').addClass('vi-size-little');
		$('body').removeClass('vi-size-medium');
		$('body').removeClass('vi-size-big');
	});

	$(document).on('click', '.js-vi-size-medium', function() {
		$('body').removeClass('vi-size-little');
		$('body').addClass('vi-size-medium');
		$('body').removeClass('vi-size-big');
	});

	$(document).on('click', '.js-vi-size-big', function() {
		$('body').removeClass('vi-size-little');
		$('body').removeClass('vi-size-medium');
		$('body').addClass('vi-size-big');
	});
});


// WEBPACK FOOTER //
// ./src/js/visually-impaired/size.js